<template>
    <view-layout :data='baseData'>
        <template #menu>
             <menu-item :name="$t('Create course')" icon='/static/images/redisign/icons-left-menu/icon-new.svg' href='/create/course' :navigate='true' />
            <!--<menu-item :name="$t('Courses')" href='/catalog/courses' :navigate='true' />
            <menu-item :name="$t('Games')" href='/catalog/challenges' :navigate='true' />
            <menu-item :name="$t('Tasks')" href='/catalog/tasks' :navigate='true' /> -->
        </template>
        <template #content>
            <div class='block2-container'>
                <div class="container_inner">
                    <div class="text1_body">
                        <div class="text1_content">
                            <h1 class="heading-large">{{$t('title1')}}</h1> 
                            <p class="text1_description">{{$t('description1')}}</p>  
                            <div class="text1_cta">
                                <a class="button black big">
                                    <a href='/create/course'>
                                        {{$t('addCourse')}}
                                    </a>
                                </a>      
                            </div>
                            <span class="text1_cta-caption">{{$t('free')}}</span>
                        </div>  
                        <div class="text1_img">
                            <img src="/static/images/demo/course-more/img-course-more-1.png" class="d-block w-100" alt=""> 
                        </div>
                    </div>     
                </div> 
                <div class='header'>
                    <div style='display:flex;align-items:baseline'>
                        <div class='name'>{{$t('Courses catalog')}}</div>
                    </div>
                    <div class="sub-header">
                        <div class='desc'>{{$t('Clear courses for everyone')}}</div>
                    </div>
                </div>
                <div class="container-courses">   
                    <div class='course' v-for='course in data.topCourses' :key='course.id'>
                        <a class="course-link" :href='`/view/${course.id}`' style="text-decoration: none;">
                            <div class="container-course">
                                <div class="course-top"> 
                                    <div class="type"><div>{{$t('Course')}}</div> <payfree :free='course.free' :bought='course.bought' /></div>
                                    <div class="right"> 
                                        <like :targetId='course.id' :likes='course.likes' :liked='!course.canLike' />
                                    </div>
                                </div>
                                
                                <div class="course-name">{{course.name}}</div>
                                
                                <div class="container-author_img">
                                    <div class="node-author">
                                        <div class="by_author">
                                            <div class='container_author_avatar' style="">
                                                <img v-if='course.authorAvatar' :src="course.authorAvatar" class='img_author_avatar' />     
                                                <img v-else src="/static/images/redisign/author_avatar2.png" class='img_author_avatar' />
                                            </div>
                                            <div class="container-by"><span class="by">{{$t('by')}}</span> <a :href='`/profile/${course.authorId}`'>{{course.authorName}}</a></div>
                                        </div>
                                        <div style="clear:both"></div>
                                        <div class='course-about'>
                                            {{course.about}}
                                        </div>
                                    </div> 
                                    <div class='image' :href='`/view/${course.id}`'>
                                        <img :src='course.imageUrl' width='200' height='150' v-if='course.imageUrl' />
                                        <img :src='`/media/screenshot/${course.id}-200x150.png`' width='200' height='150' v-else />
                                    </div>     
                                </div>
                            </div>

                            <div class="skillset-bottom">
                                <div>
                                    <template v-for='url in course.usersAvatars' :key='url'>
                                        <img :src='url' v-if='url' alt='' width='24' height='24' />
                                    </template>    
                                </div>
                                <div class="user-know"><span>{{course.usersCount}}</span> {{$t('studying')}}</div>
                            </div>
                            
                            <!-- <div class="node-author">
                                <div class="by_author">
                                    <div>
                                        <img v-if='course.authorAvatar' :src="course.authorAvatar" class='img_author_avatar' height='32' />     
                                        <img v-else src="/static/images/redisign/author_avatar.png" class='img_author_avatar' height='32' />
                                    </div>
                                    <div class="container-by"><span class="by">{{$t('by')}}</span> <a :href='`/profile/${course.authorId}`'>{{course.authorName}}</a></div>
                                </div>
                                <div style="clear:both"></div>
                            </div>                     
                            <div class='description'>
                                <div v-html='course.description'></div>
                            </div>
                            <div>
                                {{$t("Lessons count")}}: {{course.lessonsCount}}
                            </div>
                            <div>
                                <template v-for='url in course.usersAvatars' :key='url'>
                                    <img :src='url' v-if='url' alt='' width='24' height='24' />
                                </template>
                            </div> -->
                        </a>    
                    </div>
                </div>
            </div>
        </template>
    </view-layout>
</template>

<script>
import i18n from '@root/components/i18n';
import ViewLayout from '@root/course/layout_with_left_menu.vue';
import Like from '@root/components/graph_viewer/like.vue';
import MenuItem from '@root/course/menu_item.vue';
import Payfree from '@root/catalogs/payfree.vue';

export default {
    name: 'page',
    props: ["data", "baseData",],
    mixins: [i18n],
    components: {
        ViewLayout, MenuItem, Like, Payfree,
    },
    mounted: function() {
    },
    methods: {
    }
}
</script>

<style lang="scss">
    @import '@root/common';
</style>

<style lang="scss" scoped>
@import '@root/responsive';
.block2-container {
    background: white;
    border-radius: 32px 0 0 0;
    padding: 32px;
    @include device('tablet') {
        padding: 16px;
    }
    .container_inner {
        margin: 0 auto;
        background: #e9e9e9;
        padding: 5.5rem; //88px
        border-radius: 30px;
        margin-bottom: 32px;
        //1200
        @include device('tablet') {
            padding: 3rem;
        }
        //480px
        @include device('mobile') {
            padding: 2rem 0.5rem 0.5rem 0.5rem; //16px
        }
        .text1_body {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            justify-content: space-between;
            @include device('tablet') {
                flex-wrap: wrap;
            }
            .text1_content {
                width: 34rem;
                text-align: left; 
                margin-right: auto;
                margin-left: 0;
                font-size: 1.4rem; 
                color: #212529; 
                //1200px
                @include device('tablet') {
                    width: 100%;
                    text-align: center;
                    margin-left: auto;
                }
                //480px
                @include device('mobile') {
                    //max-width: 30rem;
                    text-align: center;
                    font-size: 1.2rem; 
                    margin-left: auto;
                }
                //320px
                @include device('tiny') {
                        font-size: 1rem;  
                        margin-left: auto; 
                    }
                .heading-large {
                    font-size: 2.8rem;
                    line-height: 1.1;
                    font-weight: 800;
                    margin-bottom: 1rem;
                    //768px
                    @include device('mobile') {
                        font-size: 2.5rem;    
                    }
                    //480px
                    @include device('mobile') {
                        font-size: 2rem;   
                        line-height: 1.2; 
                    }
                    //320px
                    @include device('tiny') {
                        font-size: 1.5rem;
                        max-width: 200px; 
                        padding-bottom: 1rem;
                        margin: 0 auto;         
                    }
                }
                .text1_description {
                    max-width: 48rem;
                    margin-right: 0;
                    margin-left: 0;
                    line-height: 1.6;
                    //1200px
                    @include device('tablet') {
                        text-align: center;
                        margin: 0 auto;
                        max-width: 100%;
                    }
                    //320px
                    @include device('tiny') {
                        line-height: 1.4;
                        max-width: 200px;
                    }
                }
                .text1_cta {
                    margin-top: 2rem;
                    //@media(max-width: 20rem) {
                            //margin-top: 3rem; 
                        //}
                    .button.black {
                        background: #212529; 
                        color: white;   
                        text-decoration: none;
                        &:hover {
                            background: #262a2e; 
                            box-shadow: 0px 0px 16px 0px rgb(0 0 0 / 35%);
                        }    
                    }
                    .button.big {
                        //height: 4.8rem;
                        padding: 0 3em;    
                    }
                    a {
                        color: white;
                        text-decoration: none;
                    }
                    .button {
                        position: relative;
                        display: inline-flex;
                        overflow: hidden;
                        align-items: center;
                        justify-content: center;
                        //height: 4.2rem;
                        height: 3.5rem;
                        padding: 0 1.5em;
                        cursor: pointer;
                        text-align: center;
                        border: none;
                        border-radius: 0.8rem;
                        font-size: 1.2rem;
                        //font-weight: bolder;
                        line-height: 1.1em;
                        //480px
                        @include device('mobile') {
                            font-size: 1rem;
                            height: 3.5rem;
                            //font-weight: normal;     
                        }
                        //320px
                        @include device('tiny') {
                                height: 3rem;
                        }
                    }     
                }
                .text1_cta-caption {
                    font-size: 1rem;
                    font-style: italic; 
                    color: gray;
                    @include device('mobile') {
                        font-size: 0.8rem;    
                    }   
                }
            }
            .text1_img {
                //margin-top: 5rem;
                width: 35vw;
                //1200px
                @include device('tablet'){
                    margin-top: 0;
                    margin-left: 0;
                    //width: calc(100% - 34rem - 2rem);
                    width: 45vw;
                    margin: 0 auto;
                    padding-top: 3rem;
                } 
                @include device('mobile') {
                    width: 65vw;
                    padding-bottom: 2rem;
                }
                 //320px
                 @include device('tiny'){
                    margin-bottom: 1rem;
                }    
            }
        }

    }
    & > .header {
        padding-bottom: 24px;
        .name {
            font-size: 19px;
            font-weight: 1000;
        }
        .desc {
            color: gray;
        }
    }
    .sub-header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;  
    }
} 
.course-link {
    flex: 1 1;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
}
.container-courses {
    display: flex;
    flex-direction: row;
    column-count: 2;
    column-fill: balance;
    flex-wrap: wrap;
    margin-left: -8px;
    @include device('mobile') {
        margin-left: 0;
    }
    .course {
        //border: solid 4px #F1F1F1;
        //margin: 8px;
        //border-radius: 30px;
        //flex: 1 1;
        //display: flex;
        //flex-direction: column;
        //height: 300px;
        //min-width: 200px;
        //max-width: 400px;
        position: relative;
        //overflow: hidden;
        border: solid 4px #F1F1F1;
        margin: 8px;
        border-radius: 30px;
        flex: 1 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-width: 400px;
        @include device('mobile') {
            min-width: 100%;     
            width: 100%;
            margin: 8px 0;
        }
        &:hover {
            border: solid 4px #6179e0;  
            //background: #FDFDFD; 
            box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1); 
            transform: translateY(-2px);
            transition-duration: .3s;
        }
        .container-course {
            padding: 24px 24px 0 24px;
            @include device('tiny') {
                padding: 24px 16px 0 16px;      
            }
            .course-top {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                color: gray;
                font-size: 14px;
                .type {
                    display: flex;
                    flex-direction: row;
                    .payfree {
                        position: relative;
                        display: flex;
                        margin-left: 8px;
                        top: -4px;
                        right: 0;
                        .buy {
                            padding: 0!important;
                        }
                    } 
                    .free, .buy, .bought {
                        padding: 0!important;
                    }   
                }
                
            }
            .course-name {
                margin-top: 24px;
                font-size: 26px;
                color: #212529;
                font-weight: 600;
                line-height: 1.2;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                max-height: 80px;
                @include device('mobile') {
                    font-size: 20px; 
                    max-height: 48px;     
                }
            }
            .container-author_img {
                display: flex;
                flex-direction: row-reverse;
                justify-content: left;
                margin-top: 24px;
                margin-bottom: 32px;
                @include device('mobile') {
                    flex-direction: column; 
                    margin-bottom: 16px;       
                }
                .course-about {
                    color: #212529;
                    margin-top: 0.5rem;
                    line-height: 1.2;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 4;
                    line-height: 20px;
                    max-height: 80px;
                    @include device('mobile') {
                        margin-bottom: 0.5rem;
                    }
                }
                .by_author {
                    font-size: 14px;
                    display: flex;
                    flex-direction: row;

                    .container-by {
                        display: flex;
                        flex-direction: column;
                        line-height: 1.2;
                        .by {
                            //color: #212529;
                            color: gray;
                        }    
                    }   
                }
                .container_author_avatar {
                    img {
                        width: 48px;
                        height: 48px;
                        border-radius: 13px;
                        margin-bottom: 4px; 
                        margin-right: 8px;   
                    }
                }
            }
            .image {
                //padding: 32px 0 40px 0;
                margin-right: 16px;
                @include device('mobile') {
                    margin-right: 0;
                    margin-top: 8px; 
                    img {
                        width: 100%;
                        height: 100%;
                    }      
                }
                img {
                    border-radius: 16px;
                }
            } 

            .description {
                text-overflow: ellipsis;
                overflow: hidden;
            }    
        }
        .skillset-bottom {
            display: flex;
            justify-content: space-between;
            background: #F9F9F9;
            padding: 16px 24px;
            border-bottom-left-radius: 30px;
            border-bottom-right-radius: 30px;
            @include device('tiny') {
                padding: 16px;      
            }
            //@media (max-width: 578px) {
                //padding: 16px;    
            //}
            img {
                border-radius: 100px;
                border: solid 1px #EBEBEB;
                //border: solid 1px red;
                display: inline-block;
                margin-right: -10px;
            }
            .user-know {
                font-size: 14px;
                color: #212529;
                margin-top: 3px;
                @include device('mobile') {
                    max-width: 120px;
                    text-align: right;
                    line-height: 1.2;      
                }
                //@media (max-width: 320px) {
                    //max-width: 120px;
                    //text-align: right;
                    //line-height: 1.2;
                //}
            }
        }   
    }    
}

</style>


<i18n>
{
    en: { 
        "title1": "Let's combine the learning experience",
        "description1": "Create your courses on our platform",
        "addCourse": "Create course",
        "free": "*Absolutely free",
    },
    ru: {
        "title1": "Объединим учебный опыт",
        "description1": "Создавайте свои курсы на нашей платформе",
        "addCourse": "Создать курс",
        "free": "*Абсолютно бесплатно",
        "Courses catalog": "Каталог курсов",
        "Clear courses for everyone": "Курсы понятные каждому",
        "Course": "Курс",
        "by": "Автор",
        "studying": "изучающих",
        "Lessons count": "Lessons count",
        Skillsets: "Скиллсеты",
        Courses: "Курсы",
        Games: "Игры",
        Tasks: "Задания",
        "Create course": "Создать курс",
    }
}
</i18n>
